import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { BlogdialogComponent } from './blogdialog/blogdialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { ApiservicesService } from '../../../Services/Apis/apiservices.service';
import { environment } from '../../../../environments/environment';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  MatCheckboxChange,
  MatCheckboxModule,
} from '@angular/material/checkbox';
import { PaginationComponent } from '../../../components/pagination/pagination.component';
import { ToastService } from '../../../Services/toast/toast.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateDirective } from '../../../components/Utilites/Directives/translate.directive';
@Component({
  selector: 'app-blogview',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatMenuModule,
    MatTableModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    PaginationComponent,
    ToastComponent,
    TranslateDirective,
  ],
  templateUrl: './blogview.component.html',
  styleUrl: './blogview.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BlogviewComponent implements OnInit {
  @Input() apiEndPoint!: string;
  @Input() websiteId!: string;
  @Input() pageId!: string;

  accessUrl = environment.ASSET_BLOB_URL;
  containerName = environment.ASSET_CONTAINER;
  base_url = this.accessUrl.split('.net/')[0] + '.net/';
  bloglist = new MatTableDataSource<any>();
  sourcelist: any = [];
  displayedColumns: string[] = [
    'sl.no',
    'Title',
    'images',
    'status',
    'publish',
    'actions',
  ];
  reorderMode = false;
  searchText = '';
  total_count: any;
  paginationData: any;

  constructor(
    private dialog: MatDialog,
    private apiservice: ApiservicesService,
    private toast: ToastService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.websiteId = this.route.snapshot?.queryParams['websiteId'];
    this.pageId = this.route.snapshot?.queryParams['pageId'];
    this.apiEndPoint = this.route.snapshot?.queryParams['endpoint'];
    this.getdata();
  }

  getdata() {
    this.apiservice
      .getdialoglist(this.paginationData, this.websiteId, this.pageId)
      .subscribe((res: any) => {
        if (res) {
          this.sourcelist = res.rows;
          this.total_count = res.total_count;
          this.bloglist = new MatTableDataSource<any>(res.rows);
          if (this.searchText) {
            this.searchfilter();
          }
        } else {
          console.error('Error:', res.message || 'Unknown error');
        }
      });
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getdata();
  }

  openDialog(action: any) {
    const dialogRef = this.dialog.open(BlogdialogComponent, {
      width: '75vw',
      height: '90vh',
      data: { action: action, websiteId: this.websiteId, pageId: this.pageId },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getdata();
    });
  }

  editblog(id: number, action: string) {
    const dialogRef = this.dialog.open(BlogdialogComponent, {
      width: '75vw',
      height: '90vh',
      data: {
        action: action,
        websiteId: this.websiteId,
        pageId: this.pageId,
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getdata();
    });
  }

  Viewblog(id: number, action: string) {
    const dialogRef = this.dialog.open(BlogdialogComponent, {
      width: '75vw',
      height: '90vh',
      data: {
        action: action,
        id: id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Blog view dialog closed');
    });
  }

  deleteblog(index: number) {
    const fleg = confirm('You Want to delete the record ?');
    if (fleg) {
      this.apiservice.deleteBlogData(index).subscribe({
        next: (res: any) => {
          if (res) {
            this.getdata();
          }
          this.toast.showToast('success', 'Blog Delated successfully!');
        },
        error: (err: any) => {
          console.error('Delete failed:', err);
          this.toast.showToast(
            'danger',
            'Error Delating blog. Please try again.',
          );
        },
      });
    }
  }

  searchfilter() {
    const filtered = this.sourcelist.filter((el: any) =>
      el.title.toLowerCase().includes(this.searchText),
    );
    this.bloglist = new MatTableDataSource(filtered);
  }

  publicChange(event: MatCheckboxChange, element: any) {
    let flag;
    if (event.checked) {
      flag = confirm('are you sure you want to publish!');
    } else {
      flag = confirm('are you sure you want to Unpublish!');
    }

    if (flag == true) {
      // Send as JSON object instead of FormData
      const updateData = {
        is_published: event.checked ? 1 : 0,
      };

      this.apiservice
        .updateBlog(element.id, updateData)
        .subscribe((res: any) => {
          if (res.code === 200 && res.status === true) {
            this.getdata();
            this.toast.showToast(
              'success',
              'Blog publish status updated successfully!',
            );
          } else {
            console.error('Error:', res.status || 'Unknown error');
            this.toast.showToast(
              'danger',
              'Error updating publish status. Please try again!',
            );
          }
        });
    } else {
      this.getdata();
    }
  }
  goBack(): void {
    this.router.navigate([`/websites/WebcomponentList`], {
      queryParams: { websiteId: this.websiteId, pageId: this.pageId },
    });
  }
}
